export default function useGetTier (experiences) {
  function getExperienceTiers (experienceId) {
    return experiences.value.find(experience => experience.id === experienceId).tiers;
  }

  return {
    getExperienceTiers,
  };
}
